import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { JsonResult } from '../core/json-result.model';
import { EnvironmentService } from '../core/services/environment.service';
import { Observable } from 'rxjs';
import { MasterDto } from '../models/master-dto.model'

@Injectable({
  providedIn: 'root'
})
export class MasterTableService {
  controller: string = 'MasterTable'
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

    GetAll(){
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/GetAll`;
      return this.httpClient.get<JsonResult<MasterDto[]>>(url);
    }
  
    GetMasterById(id: number): Observable<JsonResult<MasterDto>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/GetMasterById/${id}`;
      return this.httpClient.get<JsonResult<MasterDto>>(url);
    }

    GetMasterByKey(key: string): Observable<JsonResult<MasterDto>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/GetMasterByKey/${key}`;
      return this.httpClient.get<JsonResult<MasterDto>>(url);
    }
  
    CreateMaster(master: MasterDto): Observable<JsonResult<MasterDto>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/CreateMaster`;
      return this.httpClient.post<JsonResult<MasterDto>>(url, master);
    }
  
    EditMaster(master: MasterDto): Observable<JsonResult<MasterDto>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/EditMaster`;
      return this.httpClient.put<JsonResult<MasterDto>>(url, master);
    }
  
    DeleteMaster(id: number): Observable<JsonResult<any>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/DeleteMaster/${id}`;
      return this.httpClient.delete<JsonResult<any>>(url);
    }
  
    ChangeStateMaster(id: number): Observable<JsonResult<any>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/ChangeStateMaster/${id}`;
      return this.httpClient.put<JsonResult<any>>(url, null);
    }
  
    ChangeStateMasterDetail(id: number): Observable<JsonResult<any>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/ChangeStateMasterDetail/${id}`;
      return this.httpClient.put<JsonResult<any>>(url, null);
    }
  
    GetAllDetails(idMaster: number) {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/GetAllDetails/${idMaster}`;
      return this.httpClient.get<JsonResult<any>>(url);
  
    }

    GetDetailsByKey(key: string): Observable<JsonResult<any>> {
      const url = `${this.environmentService.virtualOfficeServiceUrl}MasterTable/GetDetails/${key}`;
      return this.httpClient.get<JsonResult<any>>(url);
    }
  
    // GetMasterDetailBody(key: string): Observable<JsonResult<MasterDetailBody>> {
    //   const url = `${this.environmentService.apiOFV}Master/DetailBody/${key}`;
    //   return this.httpClient.get<JsonResult<MasterDetailBody>>(url);
    // }
  
    // UpdateDetail(model:MasterDetailBody):Observable<JsonResult<MasterDetailBody>>{
    //   const url = `${this.environmentService.apiOFV}Master/UpdateDetail`;
    //   return this.httpClient.put<JsonResult<MasterDetailBody>>(url,model);
    // }
  
    // UpdateDetails(details: MasterDetailUpdateDto[], masterKey: string) {
    //   const url = `${this.environmentService.apiOFV}Master/${masterKey}/Detail`;
    //   return this.httpClient.put<any>(url, details).toPromise();
    // }
    // getDetails(masterKey: string) {
    //   const url = `${this.environmentService.apiOFV}Master/${masterKey}/Detail`;
    //   return this.httpClient.get<JsonResult<MasterDetailDto[]>>(url).toPromise();
    // }
}
